package one.healthium.ui.compose.components.banner

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

@Composable
fun <T : BannerData> BannerContainer(
    modifier: Modifier = Modifier,
    bannerHostState: BannerHostState<T> = rememberBannerHostState(),
    bannerContent: @Composable (T) -> Unit,
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(LocalBannerHostState provides bannerHostState) {
        Box(modifier = modifier) {
            content()

            BannerHost(
                hostState = bannerHostState,
                bannerContent = bannerContent,
                modifier = Modifier.align(Alignment.TopCenter)
            )
        }
    }
}
